import * as React$1 from "react";
import { Box, Link, Text } from "@opendoor/bricks-next";
//#region src/AccountForm/AccountFormCinderblocks/PasswordlessResultPage.tsx
var PasswordlessResultPage = ({ email, hasSucceeded, analyticsName }) => {
	return /* @__PURE__ */ React$1.createElement(Box, {
		width: "100%",
		py: "$36x",
		px: "$12x",
		gap: "$10x",
		$largerThanSM: { width: 480 }
	}, /* @__PURE__ */ React$1.createElement(Text, {
		tag: "h1",
		typography: "$headerMedium"
	}, hasSucceeded ? "Check your email" : "Something went wrong."), /* @__PURE__ */ React$1.createElement(Text, {
		tag: "p",
		typography: "$bodySmall"
	}, hasSucceeded ? /* @__PURE__ */ React$1.createElement(React$1.Fragment, null, "We sent an email to", " ", /* @__PURE__ */ React$1.createElement(Text, {
		tag: "span",
		typography: "$bodySmall"
	}, email), ". It includes a link that will sign you in.") : /* @__PURE__ */ React$1.createElement(React$1.Fragment, null, "We are unable to send you an email. Please reach out to", " ", /* @__PURE__ */ React$1.createElement(Link, {
		typography: "$bodySmall",
		variant: "secondary",
		href: "mailto:contact@opendoor.com",
		onPress: () => {},
		"aria-label": null,
		analyticsName: `${analyticsName}-passwordless-error-contact-us`
	}, "contact@opendoor.com"), " ", "for support")));
};
//#endregion
export { PasswordlessResultPage as default };

